import "./fairnessModal.css";
import { useEffect } from "react";
import { X } from "lucide-react";
import { AiFillSafetyCertificate } from "react-icons/ai";

const FairnessModal = ({ show, isDarkMode, onClose, battleDetail }) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [show]);

  if (!show) return null;

  return (
    <>
      <div
        className="modal-backdrop fade show fairness-backdrop"
        onClick={onClose}
      />

      <div
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        className="modal fade show d-block"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable fairness-dialog">
          <div
            className={`modal-content fairness-modal-content ${
              isDarkMode ? "bg-dark" : "bg-midnight-blue"
            }`}
          >
            {/* Header */}
            <div className="fairness-header">
              <div className="fairness-title">
                <AiFillSafetyCertificate />
                <span>Provably Fair</span>
              </div>

              <button className="fairness-close-btn" onClick={onClose}>
                <X size={22} />
              </button>
            </div>

            {/* Body */}
            <div className="fairness-body">
              <div className="fairness-row">
                <span className="label">Round ID</span>
                <span className="value">{battleDetail?.id || "-"}</span>
              </div>

              <div className="fairness-row">
                <span className="label">Box</span>
                <span className="value">
                  {battleDetail?.box_detail?.box?.name || "-"}
                </span>
              </div>

              <div className="fairness-seed-block">
                <label>Bet ID</label>
                <div className="seed-value">{battleDetail?.id || "-"}</div>
              </div>

              <div className="fairness-seed-block">
                <label>Server Seed Hash</label>
                <div className="seed-value break-word">
                  {battleDetail?.server_seed_hash || "Not Available"}
                </div>
              </div>

              <div className="fairness-seed-block">
                <label>Server Seed</label>
                <div className="seed-value break-word">
                  {battleDetail?.server_seed || "Not Available"}
                </div>
              </div>

              <div className="fairness-seed-block">
                <label>Client Seed</label>
                <div className="seed-value break-word">
                  {battleDetail?.client_seed || "Not Available"}
                </div>
              </div>

              <div className="fairness-seed-block">
                <label>EOS Hash</label>
                <div className="seed-value break-word">
                  {battleDetail?.eos_hash || "Not Available"}
                </div>
              </div>

              <div className="fairness-seed-block">
                <label>Play Count</label>
                <div className="seed-value">
                  {battleDetail?.play_count || "-"}
                </div>
              </div>

              <div className="fairness-footer">
                <div>
                  Provably fair algorithm:
                  <strong> CRYPTO_V3</strong>
                </div>

                <div className="mt-2">
                  <strong>Calculated Roll:</strong>{" "}
                  {battleDetail?.calculated_roll || "Not Available"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FairnessModal;
